import { Fragment, forwardRef } from 'react';
import { Link } from 'react-router-dom';
import UserProfilePreview from '../UserProfilePreview';
import { MENTION_PATTERN } from '../../utils/mentions';

const URL_PATTERN = /(https?:\/\/[^\s]+)/gi;
const TRAILING_PUNCTUATION = /[),.!?;:'"]+$/;

function splitTrailingPunctuation(value) {
  const match = value.match(TRAILING_PUNCTUATION);
  if (!match) return { url: value, trailing: '' };
  return {
    url: value.slice(0, -match[0].length),
    trailing: match[0],
  };
}

function renderMentions(text, keyPrefix) {
  const parts = [];
  let lastIndex = 0;
  for (const match of text.matchAll(MENTION_PATTERN)) {
    const prefix = match[1];
    const username = match[2];
    const mentionIndex = match.index + prefix.length;
    if (mentionIndex > lastIndex) parts.push(text.slice(lastIndex, mentionIndex));
    parts.push(
      <UserProfilePreview key={`${keyPrefix}-${mentionIndex}-${username}`} username={username}>
        <Link
          className="social-inline-mention"
          to={`/perfil/${encodeURIComponent(username)}`}
          onClick={(event) => event.stopPropagation()}
        >
          @{username}
        </Link>
      </UserProfilePreview>
    );
    lastIndex = mentionIndex + username.length + 1;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return parts;
}

const LinkifiedText = forwardRef(function LinkifiedText({ text, className = '' }, ref) {
  const parts = String(text || '').split(URL_PATTERN);

  return (
    <p ref={ref} className={className}>
      {parts.map((part, index) => {
        if (!/^https?:\/\//i.test(part)) {
          return <Fragment key={`${index}-${part}`}>{renderMentions(part, index)}</Fragment>;
        }

        const { url, trailing } = splitTrailingPunctuation(part);
        return (
          <Fragment key={`${index}-${url}`}>
            <a
              className="social-inline-link"
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(event) => event.stopPropagation()}
            >
              {url}
            </a>
            {trailing}
          </Fragment>
        );
      })}
    </p>
  );
});

export default LinkifiedText;
